import { forwardRef } from 'react';
import { registerLocale } from 'react-datepicker';
import ru from 'date-fns/locale/ru';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import './datepicker-calendar.css';
import calendarIcon from '../../assets/images/calendarIcon.svg';

registerLocale('ru', ru);

interface Filters {
  startDate?: Date;
  endDate?: Date;
}

interface CustomDatePickerProps {
  label?: string;
  filters?: Filters;
  setFilters?: (fn: (prev: Filters) => Filters) => void;
}

const CustomDatePicker = ({ label, filters, setFilters }: CustomDatePickerProps) => {
  const { startDate, endDate } = filters || {};

  const onChange = (dates: [Date | null, Date | null]) => {
    const [start, end] = dates;
    setFilters?.((prev) => ({
      ...prev,
      startDate: start ? new Date(start.setHours(0, 0, 0, 0)) : undefined,
      endDate: end ? new Date(end.setHours(23, 59, 59, 999)) : undefined,
    }));
  };

  const CustomInput = forwardRef<HTMLInputElement, { value?: string; onClick?: () => void }>(
    ({ value, onClick }, ref) => (
      <div className="relative w-[270px] min-h-[72px] flex flex-col">
        <label className="text-sm font-medium text-[#2d2c2c] mb-1">{label}</label>
        <input
          ref={ref}
          type="text"
          value={value}
          onChange={() => {}}
          onClick={onClick}
          readOnly
          className="w-full min-h-[44px] px-2 border border-[#dcdee0] rounded-[10px] text-sm font-normal transition-[0.2s] focus:outline focus:outline-1 focus:outline-[#007aff] focus:shadow-[0_0_0_4px_rgba(0,122,255,0.21)] hover:outline hover:outline-1 hover:outline-[#007aff] hover:shadow-[0_0_0_4px_rgba(0,122,255,0.21)]"
        />
        <div
          className="absolute top-[66%] right-[15px] -translate-y-1/2 cursor-pointer"
          onClick={onClick}
        >
          <img src={calendarIcon} alt="icon" />
        </div>
      </div>
    )
  );

  const plugDate = new Date();

  return (
    <DatePicker
      dateFormat="dd.MM.yyyy"
      selected={new Date()}
      selectsRange
      isClearable={true}
      startDate={startDate}
      endDate={endDate}
      onChange={onChange}
      customInput={<CustomInput />}
      portalId="root"
      locale={ru}
      weekDayClassName={() => 'dp-weekday'}
      calendarClassName="dp-calendar"
      dayClassName={(date) =>
        date.getDate() === plugDate.getDate() && date.getMonth() === plugDate.getMonth()
          ? 'dp-current-day'
          : 'dp-day'
      }
    />
  );
};

export default CustomDatePicker;
